/**
 * 订单列表页面路径
 */
export const ORDER_LIST_PAGE_PATH = '/order/list'
